module.exports = __webpack_public_path__ + "img/bank-002.bce8db8e.png";